import { createStore } from 'jotai';
const makeAPaymentStore = createStore();
export default makeAPaymentStore;
